import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../components/screen/common-screen-content/commonScreenContent";
import CommonFormBorder from "../../components/common-form-border/commonFormBorder";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { clearLocalStorage, isLoggedInUserAdmin, isLoggedInUserBusiness, isLoggedInUserEmployee } from "../../utils/Utils";
import { APP_CONSTANTS, ROUTES } from "../../utils/AppConstants";
import { checkFunctionalityPermission, checkOptionPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../utils/PermissionUtil";

const MenuPage = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector((state) => state.user)
    let navigate = useNavigate();
    const dispatch = useDispatch()
    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_TYPE.AUDIT) {
            return checkOptionPermission(user, PERMISSION_TYPE.AUDIT, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (pType === PERMISSION_TYPE.SUPPLIES) {
            return checkOptionPermission(user, PERMISSION_TYPE.SUPPLIES, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (pType === PERMISSION_TYPE.VISITOR) {
            return checkOptionPermission(user, PERMISSION_TYPE.VISITOR, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }
    const menuOptionsBusiness = [
        { label: 'Businesses', icon: require('../../assets/menu_option/ic_menu_business.png'), route: ROUTES.business.list, isLogout: false },
        { label: 'Locations', icon: require('../../assets/menu_option/ic_menu_location.png'), route: ROUTES.location.list, isLogout: false },
        { label: 'Employees', icon: require('../../assets/menu_option/ic_employees.png'), route: ROUTES.employee.list, isLogout: false },
        { label: 'Attendance', icon: require('../../assets/menu_option/ic_attendance.png'), route: ROUTES.attendace.list, isLogout: false },
        { label: 'Projects', icon: require('../../assets/menu_option/ic_project.png'), route: ROUTES.project.list, isLogout: false },
        { label: 'Shifts', icon: require('../../assets/menu_option/ic_shift.png'), route: ROUTES.shift.list, isLogout: false },
        { label: 'Tasks', icon: require('../../assets/menu_option/ic_task.png'), route: ROUTES.task.list, isLogout: false },
        { label: 'TimeOff', icon: require('../../assets/menu_option/ic_timeoff.png'), route: ROUTES.timeOff.list, isLogout: false },
        { label: 'Requests', icon: require('../../assets/menu_option/ic_requests.png'), route: ROUTES.requests.list, isLogout: false },
        { label: 'Messages', icon: require('../../assets/menu_option/ic_message.png'), route: ROUTES.messageChatList, isLogout: false },
        { label: 'Payroll', icon: require('../../assets/menu_option/ic_payroll.png'), route: ROUTES.payroll.menu, isLogout: false },
        { label: 'Documents', icon: require('../../assets/menu_option/ic_documents.png'), route: ROUTES.documents.list, isLogout: false },
        { label: 'Policies', icon: require('../../assets/menu_option/ic_policies.png'), route: ROUTES.policies.list, isLogout: false },
        { label: 'Assets', icon: require('../../assets/menu_option/ic_assets.png'), route: ROUTES.assets.list, isLogout: false },
        { label: 'Performance', icon: require('../../assets/menu_option/ic_performance.png'), route: ROUTES.performance.menu, isLogout: false },
        { label: 'Audit', icon: require('../../assets/menu_option/ic_audit.png'), route: ROUTES.audit.logs, isLogout: false },
        { label: 'Supplies', icon: require('../../assets/menu_option/ic_supplies.png'), route: ROUTES.supplies.menu, isLogout: false },
        { label: 'Visitor', icon: require('../../assets/menu_option/ic_visitor.png'), route: ROUTES.visitor.menu, isLogout: false },
        // { label: 'Notifications', icon: require('../../assets/menu_option/ic_notification.png'), route: ROUTES.notificationList, isLogout: false },
        // { label: 'Profile', icon: require('../../assets/menu_option/ic_profile.png'), route: ROUTES.profile, isLogout: false },
        { label: 'Logout', icon: require('../../assets/menu_option/ic_logout.png'), route: '', isLogout: true },
    ]
    let menuOptionsEmployee = [
        { label: 'Clock-In', icon: require('../../assets/menu_option/ic_menu_clock_in.png'), route: ROUTES.employee.clockIn, isLogout: false, isClockIn: true },
        { label: 'Employees', icon: require('../../assets/menu_option/ic_employees.png'), route: ROUTES.employee.list, isLogout: false },
        { label: 'Attendance', icon: require('../../assets/menu_option/ic_attendance.png'), route: ROUTES.attendace.list, isLogout: false },
        { label: 'Projects', icon: require('../../assets/menu_option/ic_project.png'), route: ROUTES.project.list, isLogout: false },
        { label: 'Shifts', icon: require('../../assets/menu_option/ic_shift.png'), route: ROUTES.shift.list, isLogout: false },
        { label: 'Tasks', icon: require('../../assets/menu_option/ic_task.png'), route: ROUTES.task.list, isLogout: false },
        { label: 'TimeOff', icon: require('../../assets/menu_option/ic_timeoff.png'), route: ROUTES.timeOff.list, isLogout: false },
        { label: 'Requests', icon: require('../../assets/menu_option/ic_requests.png'), route: ROUTES.requests.list, isLogout: false },
        { label: 'Messages', icon: require('../../assets/menu_option/ic_message.png'), route: ROUTES.messageChatList, isLogout: false },
        { label: 'Payroll', icon: require('../../assets/menu_option/ic_payroll.png'), route: ROUTES.payroll.menu, isLogout: false },
        { label: 'Documents', icon: require('../../assets/menu_option/ic_documents.png'), route: ROUTES.documents.list, isLogout: false },
        { label: 'Policies', icon: require('../../assets/menu_option/ic_policies.png'), route: ROUTES.policies.list, isLogout: false },
        { label: 'Assets', icon: require('../../assets/menu_option/ic_assets.png'), route: ROUTES.assets.list, isLogout: false },
        { label: 'Performance', icon: require('../../assets/menu_option/ic_performance.png'), route: ROUTES.performance.menu, isLogout: false },
        ...(isPermissionAllowed(PERMISSION_TYPE.AUDIT) ? [{ label: 'Audit', icon: require('../../assets/menu_option/ic_audit.png'), route: ROUTES.audit.logs, isLogout: false }] : []),
        ...(isPermissionAllowed(PERMISSION_TYPE.SUPPLIES) ? [{ label: 'Supplies', icon: require('../../assets/menu_option/ic_supplies.png'), route: ROUTES.supplies.menu, isLogout: false }] : []),
        ...(isPermissionAllowed(PERMISSION_TYPE.VISITOR) ? [{ label: 'Visitor', icon: require('../../assets/menu_option/ic_visitor.png'), route: ROUTES.visitor.menu, isLogout: false }] : []),
        // { label: 'Notifications', icon: require('../../assets/menu_option/ic_notification.png'), route: ROUTES.notificationList, isLogout: false },
        // { label: 'Profile', icon: require('../../assets/menu_option/ic_profile.png'), route: ROUTES.profile, isLogout: false },
        { label: 'Logout', icon: require('../../assets/menu_option/ic_logout.png'), route: '', isLogout: true },
    ]
    const menuOptionsAdmin = [
        { label: 'Users', icon: require('../../assets/menu_option/ic_menu_users.png'), route: ROUTES.admin.userList, isLogout: false },
        { label: 'Subscriptions', icon: require('../../assets/menu_option/ic_menu_subscription.png'), route: ROUTES.admin.subscriptionList, isLogout: false },
        { label: 'Contact Us', icon: require('../../assets/menu_option/ic_business_contact_us.png'), route: ROUTES.admin.contactUsList, isLogout: false },
        { label: 'Logout', icon: require('../../assets/menu_option/ic_logout.png'), route: '', isLogout: true },
    ]

    useEffect(() => {
        if (isLoggedInUserEmployee(user)) {
            if (checkFunctionalityPermission(user, PERMISSION_TYPE.LOCATION, PERMISSION_SUB_TYPE.LOCATION.VIEW_ALL_LOCATIONS, employeeSelectedBusiness, employeeSelectedLocation)) {
                menuOptionsEmployee.unshift({ label: 'Locations', icon: require('../../assets/menu_option/ic_menu_location.png'), route: ROUTES.location.list, isLogout: false })
            }
        }
    }, [])

    const handleMenuOptionClick = (item) => {
        if (item.isLogout === true) {
            clearLocalStorage()
            dispatch({ type: APP_CONSTANTS.LOGOUT })
        } else {
            if (item.label === 'Employees') {
                navigate(ROUTES.employee.list, {
                    state: {
                        routeType: 'employeeList',
                        flowType: APP_CONSTANTS.EMPLOYEE_SCREEN_FLOW_TYPE.EMPLOYEES
                    }
                })
            } else if (item.label === 'Attendance') {
                if (isLoggedInUserBusiness(user)) {
                    navigate(ROUTES.employee.list, {
                        state: {
                            routeType: 'attendanceList',
                            flowType: APP_CONSTANTS.EMPLOYEE_SCREEN_FLOW_TYPE.ATTENDANCE
                        }
                    })
                } else if (isLoggedInUserEmployee(user)) {
                    navigate(ROUTES.attendace.list, {
                        state: {
                            employeeId: user.data.userDetails.employeeId,
                            businessId: employeeSelectedBusiness,
                            locationId: employeeSelectedLocation
                        }
                    })
                }

            } else if (item.label === 'TimeOff') {
                if (isLoggedInUserBusiness(user)) {
                    navigate(ROUTES.employee.list, {
                        state: {
                            routeType: 'timeOffList',
                            flowType: APP_CONSTANTS.EMPLOYEE_SCREEN_FLOW_TYPE.TIME_OFF
                        }
                    })
                } else if (isLoggedInUserEmployee(user)) {
                    navigate(ROUTES.requests.employeeRequest, {
                        state: {
                            requestorId: user.data.userDetails.employeeId,
                            businessId: employeeSelectedBusiness,
                            locationId: employeeSelectedLocation,
                            requestType: APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.TIME_OFF
                        }
                    })
                }
            } else {
                navigate(item.route)
            }

        }
    }

    return (
        <>
            <CommonScreenContent>
                <div className="mp-option-container">
                    {isLoggedInUserBusiness(user) && menuOptionsBusiness.map(e => (<div className="mp-row-container" onClick={() => { handleMenuOptionClick(e) }}>
                        <div className="mp-row-img-container">
                            <img src={e.icon} className="img" />
                        </div>
                        <div className="mp-row-label">{e.label}</div>

                    </div>))}
                    {isLoggedInUserEmployee(user) && menuOptionsEmployee.map(e => (<div className="mp-row-container" onClick={() => { handleMenuOptionClick(e) }}>
                        <div className="mp-row-img-container">
                            <img src={e.icon} className="img" />
                        </div>
                        <div className="mp-row-label">{e.label}</div>

                    </div>))}
                    {isLoggedInUserAdmin(user) && menuOptionsAdmin.map(e => (<div className="mp-row-container" onClick={() => { handleMenuOptionClick(e) }}>
                        <div className="mp-row-img-container">
                            <img src={e.icon} className="img" />
                        </div>
                        <div className="mp-row-label">{e.label}</div>

                    </div>))}
                </div>
            </CommonScreenContent>
        </>
    )
}

export default MenuPage